import { Component, OnInit }            from '@angular/core';
import { Router }                       from '@angular/router';
import { UserService }                  from '../../_services/user.service'; 
import { OrgAuthService }               from '../../auth/org/orgauth.service';
import { RecaptchaModule , RecaptchaFormsModule}              from 'ng-recaptcha';

import { ShareParamService }            from '../../_services/index';
//import { IMG_ANI_REFRESH}               from '../../_models/constants';
import { first }          from 'rxjs/operators';
import { Subscription } from 'rxjs';
export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'org-forgot-password',
  templateUrl: './orgforgot-password.component.html',
  styleUrls: ['./orgforgot-password.component.css']
})
export class OrgForgotPasswordComponent implements OnInit {

  model: any = {};
  formModel: FormModel = {};
  loading:boolean = false;
  success:boolean = false;
  failure:boolean = false;
  doc: any;
  email: string = '';
  subscription: Subscription | null = null;
  constructor(
        private router: Router,
        private userService: UserService,
        private shareParam: ShareParamService, 
        private authOrg: OrgAuthService) { 
        }

    ngOnInit() {
      //this.IMG_ANI_REFRESH = IMG_ANI_REFRESH;
      this.email = this.shareParam.getSelectedParam()?.toLowerCase().trim();
      if (this.email != "" && this.email != undefined){
        this.model.email = this.email;
      }            
    }


  orgForgotyourpassword(){
        this.loading = true;
        this.subscription = this.userService.orgForgotyourpassword(this.model)
            .pipe(first())
            .subscribe(
                data => {//alert('Registration is successful');
                    this.model = {};
                    this.success = true;
                    //this.router.navigate(['/ind-login']);
                },
                error => {
                    this.failure = true;
                    this.loading = false;
                });
  }
  reloadPage(){
    window.location.reload();
  }
 ngOnDestroy(){
    try{
      this.subscription?.unsubscribe();
    }catch(e){

    }
  }
}
